<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import { useAuthStore } from './stores/auth';

// Restore any existing session (httpOnly cookie) on load.
const auth = useAuthStore();
const router = useRouter();

// Session expiry: when a token refresh fails (24h idle window elapsed), drop
// local auth state and bounce the user to login to re-authenticate.
function onSessionExpired() {
  if (!auth.user) return; // never had a session — ignore stray 401s
  auth.user = null;
  const cur = router.currentRoute.value;
  if (cur.name !== 'login') {
    router.push({ name: 'login', query: { redirect: cur.fullPath, expired: '1' } });
  }
}

onMounted(async () => {
  window.addEventListener('auth:session-expired', onSessionExpired);
  await auth.fetchMe();
});

onUnmounted(() => window.removeEventListener('auth:session-expired', onSessionExpired));
</script>

<template>
  <RouterView />
</template>
